export const isNativeAppByUserAgent = () => {
  const devicePattern = /FRNativeApp(\/uq-ios|\/uq-android|\/pl-android|\/pl-ios)|gu-app/i
  return devicePattern.test(navigator?.userAgent)
}
